import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setChatBot } from "../../../redux/chatBotSlice";
import styles from "./ViewAllTemples.module.css";
import {
  APIProvider,
  Map,
  Marker,
  // InfoWindow,
} from "@vis.gl/react-google-maps";
import {
  AxiosInstance,
  DEFAULT_CENTER,
  GOOGLE_MAPS_API_KEY,
} from "../../../axios/index";
import { GiSettingsKnobs } from "react-icons/gi";
import TempleCard from "../../../components/templecard/TempleCard";
import HomeSearchInput from "../../../components/homesearchinput/HomeSearchInput";
import { cookies } from "../../../axios/index";
import TempleFilterPopup from "../../../components/filterpopup/TempleFilterPopup";
import MapController from "../../MapController";
import CustomizButton from "../../../components/buttons/CustomizButton";
import Chatbot from "../../../components/chatbot/Chatbot";

const ViewAllTemples = ({ location }) => {
  const locationState = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const debounceRef = useRef(null);
  const userInteractedRef = useRef(false);
  const { chatBot } = useSelector((state) => state.chatBot);
  const groupID = locationState?.state?.groupID || "";
  const groupName = locationState?.state?.groupName || "";
  const dashBoardSearch = locationState?.state?.QUERY || "";
  const [active, setActive] = useState(false);
  const [temples, setTemples] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [cameraInfo, setCameraInfo] = useState({
    center: DEFAULT_CENTER,
    zoom: 14,
  });
  const [locations, setLocations] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [query, setQuery] = useState("");
  const suggestions = [
    "List famous temples built during the Chola dynasty.",
    "Where can I visit a temple built entirely of stone?",
    "Which temples are associated with Lord Rama’s journey?",
    "Suggest a 3-day tour plan to visit all Navagraha temples around Kumbakonam.",
    "Which temples can I cover in a one-day trip from Delhi?",
  ];
  const [message, setMessage] = useState("");
  const [wishlisted, setWishlisted] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [forceInactive, setForceInactive] = useState(false);
  const [manualTrigger, setManualTrigger] = useState(0);
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);
  const [userLocation, setUserLocation] = useState(
    location ? { lat: location.lat, lng: location.lng } : ""
  );

  const emptyFilters = {
    tag: null, // single-select
    religion: [], // multi
    facilities: [], // multi
    group: [], // multi
    ownership: null, // single
    state: null,
    district: null,
    city: null,
  };
  const [filters, setFilters] = useState(emptyFilters);

  useEffect(() => {
    if (locationState.state) {
      const timer = setTimeout(() => {
        navigate(locationState.pathname, { replace: true, state: null });
        setFilters(emptyFilters);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [locationState.pathname]);

  useEffect(() => {
    if (dashBoardSearch && dashBoardSearch.length > 0) {
      setQuery(dashBoardSearch);
      setManualTrigger((prev) => prev + 1);
    }
  }, [dashBoardSearch]);
  useEffect(() => {
    if (groupID && groupName) {
      setFilters((prev) => ({
        ...prev,
        group: [
          {
            value: groupID,
            label: groupName,
          },
        ],
      }));
      setAppliedFilterCount(1);
    }
  }, [groupID, groupName]);

  const userCookie = cookies.get("userDetails");
  const userDetails = userCookie || null;
  const user_id = userDetails?.user_id;
  // inside ViewAllTemples component

  const debouncedFetchTemples = (visibleBounds) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      fetchTemples(0, visibleBounds);
    }, 500); // 500ms debounce
  };
  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (location) {
      setCameraInfo({
        center: { lat: location.lat, lng: location.lng },
        zoom: 14,
      });
      setUserLocation({ lat: location.lat, lng: location.lng });
    } else {
      setCameraInfo({
        center: DEFAULT_CENTER,
        zoom: 14,
      });
      // setUserLocation(DEFAULT_CENTER);
    }
  }, [location]);

  useEffect(() => {
    const initialWishlist = {};
    temples.forEach((temple) => {
      initialWishlist[temple.id] = temple.is_fav || false;
    });
    setWishlisted(initialWishlist);
  }, [temples]);

  const fetchTemples = async (is_aiSearch, visibleBounds) => {
    try {
      const payload = {
        search: query || "",
        tag_id: filters?.tag?.value || "",
        religion_id:
          Array.isArray(filters?.religion) && filters.religion.length > 0
            ? filters.religion.map((r) => r.value)
            : "",
        state_name: filters?.state?.label || "",
        district_name: filters?.district?.value || "",
        city_name: filters?.city?.value || "",
        group_id:
          Array.isArray(filters?.group) && filters.group.length > 0
            ? filters.group.map((g) => g.value)
            : "",
        facilities_id:
          Array.isArray(filters?.facilities) && filters.facilities.length > 0
            ? filters.facilities.map((f) => f.value)
            : "",
        ownership: filters?.ownership?.value ? [filters.ownership.value] : "",
        user_id: user_id || "",
        location: visibleBounds || "",
        // is_aiSearch: is_aiSearch,
        is_aiSearch: query && query.length > 0 ? 1 : 0,
      };

      const response = await AxiosInstance.post(
        "/temple/viewall_temples",
        payload
      );

      if (response?.status === 200 && response?.data?.status) {
        userInteractedRef.current = false;
        const userSearch = response?.data?.details || [];

        // ✅ Always returns an array
        const userMessages = (chatBot || []).filter(
          (item) => item.type === "user"
        );

        const formattedQuery = `search: ${query}`.trim().toLowerCase();

        // ✅ Safe check even if empty
        const exists = userMessages.some(
          (msg) => msg?.message?.trim().toLowerCase() === formattedQuery
        );

        if (query?.length > 0 && !exists) {
          if (userSearch.length > 0) {
            // setIsOpen(true);
            dispatch(
              setChatBot([
                ...(chatBot || []),
                {
                  type: "user",
                  message: `search: ${query}`,
                  search: query || "",
                },
                ...userSearch.map((item) => ({
                  type: "bot",
                  heading: item.title,
                  description: item.para,
                  list: item.list || [],
                })),
              ])
            );
          } else {
            // setIsOpen(true);
            dispatch(
              setChatBot([
                ...(chatBot || []),
                {
                  type: "user",
                  message: `search: ${query}`,
                  search: query || "",
                },
                {
                  type: "bot",
                  heading:
                    "We appreciate your curiosity, but HolyBharat is here to guide you through India's divine heritage — temples, traditions, and spiritual insights.",
                  description:
                    "Please try searching for temple names, locations, deities, or rituals to explore our spiritual collection.",
                  title: "You can try asking:",
                  list: [
                    "Famous temples in Tamil Nadu",
                    "Temples dedicated to Lord Shiva",
                    "Daily pooja timings of Tirupati temple",
                    "Festivals celebrated at Meenakshi Amman Temple",
                  ],
                },
              ])
            );
          }
        }
        if (response?.data?.temple.length > 0) {
          const mappedTemples = response?.data?.temple?.map((item) => ({
            id: item.id,
            temple_name: item.temple_name,
            city: item.city_name,
            district: item.district_name,
            state: item.state_name,
            image: item.image,
            tagline: item.main_deity || "",
            brief_note: item.brief_note || "",
            address: item.address || "",
            is_fav: item.is_fav,
          }));
          setTemples(mappedTemples);

          const locs = response?.data?.temple?.map((item) => ({
            id: item.id,
            temple_name: item.temple_name,
            latitude: item.latitude,
            longitude: item.longitude,
            is_fav: item.is_fav,
          }));
          setLocations(locs);

          setCameraInfo({
            center: {
              lat: parseFloat(response?.data?.temple[0]?.latitude),
              lng: parseFloat(response?.data?.temple[0]?.longitude),
            },
            zoom: 14,
          });
        } else {
          setLocations([]);
          setTemples([]);
          setMessage("No temples found");
        }

        setActive(false);
        setForceInactive(true);
      } else {
        // API says no temples found
        userInteractedRef.current = false;
        setTemples([]);
        setLocations([]);
        setMessage(response?.data?.message || "No temples found.");
      }
    } catch (error) {
      userInteractedRef.current = false;
      console.error("Error fetching temples:", error);
      setTemples([]);
      setLocations([]);
      setMessage("Something went wrong. Please try again.");
    } finally {
      userInteractedRef.current = false;
      setActive(false);
      setForceInactive(true);
      setShowPopup(false);
    }
  };

  // Fetch temple data from API (initial load + search)
  useEffect(() => {
    fetchTemples(0);
  }, [manualTrigger]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setActive(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleWishlist = async (templeId) => {
    try {
      const payload = {
        user_id: user_id,
        temple_id: templeId,
        created_dt: new Date().toISOString().slice(0, 19).replace("T", " "),
      };

      const res = await AxiosInstance.post("/temple/add_fav", payload);

      if (res.data.status) {
        // Toggle state locally (backend decides add/remove)
        setWishlisted((prev) => ({
          ...prev,
          [templeId]: !prev[templeId],
        }));
      } else {
        console.warn("Failed:", res.data.message);
      }
    } catch (err) {
      console.error("Wishlist error:", err);
    }
  };
  const handleClearFilters = () => {
    setFilters(emptyFilters);
    setAppliedFilterCount(0);
    setManualTrigger((prev) => prev + 1);
  };
  const handleApply = (appliedFilters, count) => {
    setFilters(appliedFilters);
    setAppliedFilterCount(count);
    setQuery("");
    setManualTrigger((prev) => prev + 1);
  };

  // ✅ Scroll listener
  useEffect(() => {
    const handleScroll = () => {
      const pageScroll = window.scrollY;
      const cardsScroll =
        document.querySelector(`.${styles.containerWrapper}`)?.scrollTop || 0;

      if (pageScroll > 20 || cardsScroll > 50) {
        setScrolled(true); // stick to top
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    const cardsContainer = document.querySelector(
      `.${styles.containerWrapper}`
    );
    if (cardsContainer) {
      cardsContainer.addEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (cardsContainer) {
        cardsContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <div
      className="container-fluid"
      style={{
        position: "relative",
        marginTop: scrolled ? "10vh" : "15vh", // dynamically change
        transition: "margin-top 0.3s ease", // smooth transition
      }}
    >
      <div className="row">
        {/* Search Header */}
        <header
          ref={containerRef}
          className={`${styles.header} 
    ${active ? styles.active : ""} 
    ${showPopup ? styles.disabled : ""} 
    ${scrolled ? styles.scrolled : ""}`}
          onClick={() => !showPopup && setActive(true)}
        >
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-12 col-md-10 mb-4 mb-md-0">
                <div className={styles.input_wrapper}>
                  <HomeSearchInput
                    query={query}
                    setQuery={setQuery}
                    suggestions={suggestions}
                    setManualTrigger={setManualTrigger}
                    setFilters={setFilters}
                    setAppliedFilterCount={setAppliedFilterCount}
                    emptyFilters={emptyFilters}
                  />
                </div>
              </div>

              {/* Filter Button */}
              <div className="col-12 col-md-2">
                <div
                  style={{
                    position: "relative",
                    display: "block",
                    width: "100%",
                  }}
                >
                  <CustomizButton
                    type="button"
                    label="Filters"
                    variant="primary"
                    icon={<GiSettingsKnobs />}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowPopup(true);
                      setActive(false);
                      setForceInactive(true);
                    }}
                    style={{
                      border:
                        appliedFilterCount > 0
                          ? "3px solid #142454"
                          : "3px solid #fa8316",
                      width: "100%", // ✅ makes sure button stretches full width in mobile
                    }}
                  />

                  {appliedFilterCount > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-8px", // ✅ always relative to button, not col
                        background: "#142454",
                        color: "white",
                        borderRadius: "50%",
                        padding: "3px 7px",
                        fontSize: "12px",
                      }}
                    >
                      {appliedFilterCount}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Popup */}
            <TempleFilterPopup
              show={showPopup}
              onClose={() => setShowPopup(false)}
              locationState={{ value: groupID, label: groupName }}
              onApply={handleApply}
              onClear={handleClearFilters}
              emptyFilters={emptyFilters}
              filters={filters}
              setFilters={setFilters}
            />
          </div>
        </header>

        {active && (
          <div className={styles.overlay} onClick={() => setActive(false)} />
        )}

        <div className={`row ${styles.pageContainer}`}>
          {/* Left map */}
          <div className="col-md-4 p-0">
            <div className={styles.mapWrapper}>
              <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
                <div style={{ width: "100%", height: "100%" }}>
                  <Map
                    id="main-map"
                    defaultZoom={14}
                    // minZoom={10}
                    // maxZoom={20}
                    defaultCenter={{
                      lat: parseFloat(cameraInfo?.center?.lat),
                      lng: parseFloat(cameraInfo?.center?.lng),
                    }}
                    gestureHandling="greedy"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "20px",
                      overflow: "hidden",
                    }}
                    // onDrag={() => {
                    //   userInteractedRef.current = true;
                    // }}
                    onDragend={() => {
                      userInteractedRef.current = true;
                      setQuery("");
                    }}
                    onDragEnd={() => {
                      userInteractedRef.current = true;
                      setQuery("");
                    }}
                    onZoomChanged={() => {
                      userInteractedRef.current = true;
                      setQuery("");
                    }}
                    onCameraChanged={(e) => {
                      // console.log("userInteractedRef", userInteractedRef);

                      if (!userInteractedRef.current) return;
                      setQuery("");
                      const { detail } = e;
                      const bounds = detail.bounds;
                      const { north, south, east, west } = bounds;

                      const visibleBounds = {
                        northEast: { lat: north, lng: east },
                        southWest: { lat: south, lng: west },
                        northWest: { lat: north, lng: west },
                        southEast: { lat: south, lng: east },
                      };

                      if (userInteractedRef.current) {
                        debouncedFetchTemples(visibleBounds);
                      }
                    }}
                    options={{
                      disableDefaultUI: true,
                      zoomControl: true, // ✅ only plus & minus buttons
                      fullscreenControl: false, // ❌ disable fullscreen
                      streetViewControl: false, // ❌ disable street view
                      mapTypeControl: false, // ❌ disable map type (satellite/terrain)
                      keyboardShortcuts: false, // ❌ disable keyboard shortcuts
                      rotateControl: false, // ❌ disable rotate
                      scaleControl: false, // ❌ disable scale bar
                      // ✅ Restrict zooming out (1 = world, 3 = continent, 5 = country, etc.)
                      minZoom: 3,
                      maxZoom: 15, // optional (prevents over zooming in)
                    }}
                  >
                    {/* ✅ User Location Marker */}
                    {userLocation && (
                      <Marker
                        position={{
                          lat: parseFloat(userLocation.lat),
                          lng: parseFloat(userLocation.lng),
                        }}
                        icon={{
                          url: `data:image/svg+xml;utf-8,
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="%23ff6f00" viewBox="0 0 512 512">
        <path d="M256 0C167.6 0 96 71.6 96 160c0 48.1 20.5 91.3 53.2 121.6L246 505.5c2.9 4.6 8.1 6.5 12.9 6.5s10-1.9 12.9-6.5l96.8-223.9C395.5 251.3 416 208.1 416 160c0-88.4-71.6-160-160-160zm0 224c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"/>
      </svg>`,
                          scaledSize: { width: 32, height: 32 },
                          anchor: { x: 16, y: 32 },
                        }}
                        onClick={() =>
                          setSelectedMarker({
                            latitude: userLocation.lat,
                            longitude: userLocation.lng,
                            temple_name: "You are here",
                            address: "",
                            image: "",
                          })
                        }
                      />
                    )}
                    {locations.map((loc, index) => (
                      <Marker
                        key={index}
                        position={{
                          lat: parseFloat(loc.latitude),
                          lng: parseFloat(loc.longitude),
                        }}
                        onClick={() => setSelectedMarker(loc)}
                      />
                    ))}
                    <MapController
                      lat={cameraInfo.center.lat}
                      lng={cameraInfo.center.lng}
                    />
                    {/* markers and infowindow */}
                  </Map>
                </div>
              </APIProvider>
            </div>
          </div>

          {/* Right cards */}
          <div className={`col-md-8 ${styles.containerWrapper}`}>
            <div className="row g-4">
              {temples.length > 0 ? (
                temples.map((temple) => (
                  <div
                    key={temple.id}
                    className="col-12 col-sm-6 col-md-4 d-flex p-2"
                  >
                    <TempleCard
                      temple={temple}
                      isWishlisted={wishlisted[temple.id] || false}
                      onWishlist={handleWishlist}
                    />
                  </div>
                ))
              ) : (
                <p className="text-center w-100 mt-4">{message}</p>
              )}
            </div>
          </div>
        </div>
        <Chatbot
          conversations={chatBot}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      </div>
    </div>
  );
};

export default ViewAllTemples;
